var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',{attrs:{"multiple":""},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"text-h6"},[_vm._v("\n      Global Reloads\n    ")]),_c('v-expansion-panel-content',[(_vm.panel.includes(0))?[_c('v-lazy',{attrs:{"options":{
            threshold: .5
          },"min-height":"145","transition":"fade-transition"}},[_c('component-body')],1)]:_vm._e()],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }